export default __webpack_public_path__ + "static/media/14.aa8566e8.png";